import * as Sentry from "@sentry/react";
import Member from "../../services/api/member";
import { ROUTES } from "../../utils/constants";
// import { ROUTES } from "../../utils/constants";
import {
  INITIATE_VIEW_MEMBER_DATA,
  SET_SELECTED_PENDING_TRANSFER_MEMBER_REMARKS,
} from "../actionTypes/dashboard";

export const fetchMemberTransferData = async (dispatch, type) => {
  dispatch({
    type: INITIATE_VIEW_MEMBER_DATA,
    payload: {
      pageNumber: 0,
      pageSize: 5,
      type,
    },
  });
};

export const forwardMember = async (
  payload,
  memberData,
  navigate,
  setShowToast
) => {
  try {
    await Member.forwardMember({
      data: payload,
      memberId: memberData.id,
      transferId: memberData.transferId,
    });
    setShowToast({
      message: "Successfully forward!",
      severity: "success",
    });
    setTimeout(() => {
      navigate(`/${ROUTES.MEMBER_TRANSFER.path}`);
    }, 2000);
  } catch (err) {
    setShowToast({
      message: err.message || "Something went wrong. Please contact support.",
      severity: "error",
    });
    Sentry.captureException(err);
  }
};

export const fetchTransferMemberRemarksData = async (dispatch, memberId) => {
  const result = await Member.getMemberRemarks({
    id: memberId,
  });

  dispatch({
    type: SET_SELECTED_PENDING_TRANSFER_MEMBER_REMARKS,
    payload: result.data,
  });
};
export const acceptMember = async (
  payload,
  memberData,
  navigate,
  setShowToast
) => {
  try {
    await Member.acceptMember({
      data: payload,
      memberId: memberData.memberId,
      transferId: memberData.transferId,
    });

    setShowToast({
      message: "Successfully Accept!",
      severity: "success",
    });
    setTimeout(() => {
      navigate(`/${ROUTES.MEMBER_TRANSFER.path}`);
    }, 2000);
  } catch (err) {
    setShowToast({
      message: err.message || "Something went wrong. Please contact support.",
      severity: "error",
    });
    Sentry.captureException(err);
  }
};

export const rejectMember = async (
  dispatch,
  payload,
  memberData,
  navigate,
  setShowToast
) => {
  try {
    await Member.rejectMember({
      data: { reason: { data: payload } },
      memberId: memberData.memberId,
      transferRequestId: memberData.transferId,
    });

    setShowToast({
      message: "Successfully Reject!",
      severity: "success",
    });
    setTimeout(() => {
      navigate(`/${ROUTES.MEMBER_TRANSFER.path}`);
    }, 2000);
  } catch (err) {
    setShowToast({
      message: err.message || "Something went wrong. Please contact support.",
      severity: "error",
    });
    Sentry.captureException(err);
  }
};

export const transferMember = async (dispatch, data) => {
  try {
    await Member.transferMember({
      data,
      memberId: data.memberId,
    });
    // navigate(ROUTES.FRIEND_SEARCH.path);
  } catch (err) {
    alert(err.message || "Something went wrong. Please contact support.");
    Sentry.captureException(err);
  }
};
